import { DOWNLOAD_PAGES, ROUTES } from "@/config/routes";

export const PLAN_CELL_FREE = "Free";
export const PLAN_CELL_PAID = "Pro · $10/mo";

export const PUBLIC_PLANS = [
  {
    id: "starter",
    name: "Starter",
    listPrice: "",
    launchPrice: "Free",
    featured: false,
    paid: false,
  },
  {
    id: "pro",
    name: "Pro",
    listPrice: "$10",
    launchPrice: "$10",
    featured: true,
    paid: true,
  },
] as const;

const DOWNLOAD_PLAN_PRICING: Record<(typeof DOWNLOAD_PAGES)[number]["route"], string> = {
  [ROUTES.invoicesBulkExport]: PLAN_CELL_PAID,
  [ROUTES.invoicesPdfs]: PLAN_CELL_FREE,
  [ROUTES.invoicesReceipts]: PLAN_CELL_FREE,
  [ROUTES.invoicesCreditNotes]: PLAN_CELL_FREE,
  [ROUTES.invoicesPayLinks]: PLAN_CELL_FREE,
};

export const PUBLIC_FEATURE_MATRIX: {
  feature: string;
  pricing: string;
}[] = [
  { feature: "Browse & search", pricing: PLAN_CELL_FREE },
  { feature: "Download Pay Links", pricing: DOWNLOAD_PLAN_PRICING[ROUTES.invoicesPayLinks] },
  { feature: "Export History", pricing: PLAN_CELL_FREE },
  { feature: "Download Invoice PDFs", pricing: DOWNLOAD_PLAN_PRICING[ROUTES.invoicesPdfs] },
  { feature: "Download Receipts", pricing: DOWNLOAD_PLAN_PRICING[ROUTES.invoicesReceipts] },
  {
    feature: "Download Credit Notes",
    pricing: DOWNLOAD_PLAN_PRICING[ROUTES.invoicesCreditNotes],
  },
  { feature: "Bulk Export PDFs", pricing: DOWNLOAD_PLAN_PRICING[ROUTES.invoicesBulkExport] },
];
